import A from './types';
import format from 'date-fns/format';
import isEmpty from 'lodash/isEmpty';

const initialState = {
  paymentHistory: {
    data: [],
  },
  paymentNextBillDate: {
    data: [],
  },
};
const compare = (key) => (obj1, obj2) => {
  var date1Arr = obj1[key].split('/');
  var date2Arr = obj2[key].split('/');
  var value1 = new Date(`20${date1Arr[2]}-${date1Arr[1]}-${date1Arr[0]}`);
  var value2 = new Date(`20${date2Arr[2]}-${date2Arr[1]}-${date2Arr[0]}`);
  return value2 - value1;
}

const joinBillingList = (data) => {
  const newArr = [...data[0].data, ...data[1].data.historyList];
  return newArr.sort(compare('date'));
}

const joinNextBillingList = (data) => {
  if (!isEmpty(data[0].data) && data[0].data.next_billing_date) {
    data[0].data.date = data[0].data.next_billing_date;
  };
  const newArr = isEmpty(data[0].data) ? [...data[1].data.nextBillList] : [data[0].data, ...data[1].data.nextBillList];

  return newArr.sort(compare('date'));
}

const reducer = (state, action) => {
  switch (action.type) {
    case A.GET_PAYMENT_HISTORY: {
      if (action.pending) {
        return {
          ...state,
          paymentHistory: {
            ...state.paymentHistory,
            loading: true,
            error: false,
            data: [],
          },
        };
      }
      if (action.error) {
        return {
          ...state,
          paymentHistory: {
            ...state.paymentHistory,
            loading: false,
            error: action.error,
            data: [],
          },
        };
      }
      if (action.payload[0].state_message.toLowerCase() === 'success') {
        return {
          ...state,
          paymentHistory: {
            ...state.paymentHistory,
            loading: false,
            error: false,
            data: joinBillingList(action.payload),
          },
        };
      }
      return {
        ...state,
        paymentHistory: {
          ...state.paymentHistory,
          loading: false,
          error: action.error,
          data: [],
        },
      };
    }
    case A.GET_PAYMENT_NEXT_BILL_DATE: {
      if (action.pending) {
        return {
          ...state,
          paymentNextBillDate: {
            ...state.paymentNextBillDate,
            loading: true,
            error: false,
            data: [],
          },
        };
      }
      if (action.error) {
        return {
          ...state,
          paymentNextBillDate: {
            ...state.paymentNextBillDate,
            loading: false,
            error: action.error,
            data: [],
          },
        };
      }
      if (action.payload[0].state_message.toLowerCase() === 'success') {
        return {
          ...state,
          paymentNextBillDate: {
            ...state.paymentNextBillDate,
            loading: false,
            error: false,
            data: joinNextBillingList(action.payload),
          },
        };
      }
      return {
        ...state,
        paymentNextBillDate: {
          ...state.paymentNextBillDate,
          loading: false,
          error: action.error,
          data: [],
        },
      };
    }
  }
  return null;
};

export default {reducer, initialState};



// WEBPACK FOOTER //
// ./src/modules/paymentHistoryPage/reducer.js